import { controls, grouped } from "../controls";
const bio_enrolment_types = {
  label: "Bio Enrolment Types",
  pageLabel: "Bio Enrolment Types", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  bulk: { columns: ["bio_enrolment_type_code", "bio_enrolment_type_display"] },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "bio_enrolment_type_code", maxlength: 10 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Description", description: 'Starting partial search. e.g. You can search for Sugar Cane by typing sugar.' }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "bio_enrolment_type_display", width: "col-sm-4", maxlength: 100 }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Code", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "bio_enrolment_type_code", isRequired: true, maxlength: 10 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Description", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "bio_enrolment_type_display", isRequired: true, width: "col-sm-4", maxlength: 100 }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Bio Enrolment Types",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Bio Enrolment Type Code", accessor: "bio_enrolment_type_code", },
      { Header: "Bio Enrolment Type", accessor: "bio_enrolment_type_display", },
    ]
  }
};
export default bio_enrolment_types;